export default "__VITE_ASSET__oxrqUO9z__"